<template>
  <div class="image-container">
    <img :src="imageUrl">
  </div>
</template>
<script>
export default {
  props: {
    imageSrc: {
      type: String,
      default: ''
    }
  },
  computed: {
    imageUrl() {
      return this.imageSrc || 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
    }
  }
}
</script>
<style scoped lang="scss">
.image-container {
  position: relative;
  width: 100%;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
  > img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
}
</style>
